<template>
  <div class="user-details-content">
    <v-list-item class="border-light-grey ">
      <v-list-item-content>
        <v-list-item-title class="body-2 text--secondary" v-text="name" />
      </v-list-item-content>

      <v-list-item-action>
        <div class="body-2 text--primary">
          {{ value }}
        </div>
      </v-list-item-action>
    </v-list-item>
    <v-divider class="border-light-grey" v-if="divider" />
  </div>
</template>

<script>
/**
 * User details content
 * @description To be used to show the user detail
 */
export default {
  name: "UserContent",
  /**
   * ---------------- Props ------------------
   */
  props: {
    /**
     * Name of the property
     */
    name: { type: String, required: true, default: "" },
    /**
     * Value of the property
     */
    value: { type: String, required: true, default: "" },
    /**
     * Determines whether to show divider or not
     */
    divider: { type: Boolean, default: true },
  },
};
</script>
